
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.75 7h2.219c.918 0 1.716.61 1.938 1.5L11.532 19h11.469l1.906-7H11.251l-.5-2h16.75l-2.594 9.531A1.969 1.969 0 0123.001 21H11.532c-.917 0-1.714-.61-1.938-1.5L6.969 9H4.75a1 1 0 010-2zm17 14c1.645 0 3 1.355 3 3s-1.355 3-3 3-3-1.355-3-3 1.355-3 3-3zm-9 0c1.645 0 3 1.355 3 3s-1.355 3-3 3-3-1.355-3-3 1.355-3 3-3zm0 2c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1zm9 0c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1z"}})])
          )
        }
      }
    